// extracted by mini-css-extract-plugin
module.exports = {"bb":"bb__ivi2Z","add-to-basket-for-teasers":"add-to-basket-for-teasers__UvX5I","add-to-basket-for-teasers__plus-icon":"add-to-basket-for-teasers__plus-icon__lH_sN"};